module.exports = __webpack_public_path__ + "static/006.thumb-80798732cb451c6f0e813dd7013915f0.jpg";